import Cookies from 'js-cookie'

/**
 * SubscribePopup component
 * @author Dayne Coulson-Hoffacker
 */
export default class SubscribePopup {
  /**
   * Constructs a new SubscribePopup instance
   * @param {Object} options - Options object.
   * @param {HMTLElement} options.element - Container element.
   */
  constructor (options) {
    this.element = options.element
    this.closeBtns = this.element.queryAll('[data-component="close-btn"]')

    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this.element.classList.remove('visible')
        Cookies.set('subscribe-popup', 'hide')
      })
    })

    const cookieExists = Cookies.get('subscribe-popup')

    if (!cookieExists) {
      setTimeout(() => {
        this.element.classList.add('visible')
      }, 45000)
    }

  }

}



// WEBPACK FOOTER //
// ./components/subscribe-popup/index.js